var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiglaReghin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.933,
    height: 138.368,
    viewBox: "0 0 115.933 138.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4",
    x: 0,
    y: 0,
    width: 115.933,
    height: 138.368,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_reghin",
    "data-name": "logo reghin",
    transform: "translate(-71 -20.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 71, 20.1)",
    filter: "url(#Path_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M86,32.1V96.02c0,32.87,42.289,44.279,42.966,44.448h0c.677-.19,42.966-11.578,42.966-44.448V32.1Z",
    transform: "translate(-71 -20.1)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M208.047,415.906c-14.731-7.091-20.658-16.467-21.547-29.039,5.418,3.2,9.419-1.926,12.763-1.968,3.365-.021,4.953,2.984,8.8,2.963,3.852.021,5.44-3.006,8.8-2.963,3.344.021,7.345,5.186,12.805,1.926-.889,12.594-6.794,21.97-21.547,29.082l-.042.021Z",
    transform: "translate(-79.228 -278.126)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M206.637,415.029l-.194-.1c-14.079-6.777-20.784-15.821-21.739-29.324l-.046-.654.565.333c3.389,2,6.216.579,8.71-.674a9.6,9.6,0,0,1,3.874-1.342,8.1,8.1,0,0,1,4.266,1.453,8.6,8.6,0,0,0,4.542,1.51h.037a8.554,8.554,0,0,0,4.5-1.512,8.061,8.061,0,0,1,4.277-1.451,9.463,9.463,0,0,1,3.873,1.335c2.5,1.256,5.334,2.68,8.751.639l.567-.338-.047.658c-.955,13.523-7.659,22.58-21.741,29.368Zm-21.2-28.84c1.1,12.848,7.657,21.527,21.2,28.072,13.539-6.557,20.1-15.248,21.2-28.111-3.492,1.759-6.446.276-8.844-.929a9.044,9.044,0,0,0-3.571-1.262,7.46,7.46,0,0,0-3.926,1.359,9.113,9.113,0,0,1-4.836,1.6h-.085a9.149,9.149,0,0,1-4.842-1.6,7.568,7.568,0,0,0-3.883-1.361h-.033a9.183,9.183,0,0,0-3.571,1.269C191.851,386.429,188.906,387.909,185.441,386.188Z",
    transform: "translate(-77.776 -276.842)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M208.041,409.769l.169,6.138-.021.021-.021-.021c-14.731-7.091-20.658-16.467-21.568-29.039,5.418,3.2,9.419-1.926,12.763-1.968,3.365-.021,4.974,2.984,8.8,2.963Z",
    transform: "translate(-79.307 -278.127)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M206.732,415.131l-.222-.222c-14.036-6.77-20.733-15.809-21.709-29.3l-.047-.655.566.334c3.389,2,6.216.579,8.71-.674a9.6,9.6,0,0,1,3.874-1.342h.037a8.264,8.264,0,0,1,4.241,1.456,8.6,8.6,0,0,0,4.491,1.508h.038l.348,0-.129,22.249.174,6.282Zm-21.194-28.941c1.107,12.736,7.569,21.376,20.857,27.9l-.154-5.6.125-21.566a9.42,9.42,0,0,1-4.527-1.593,7.612,7.612,0,0,0-3.9-1.364h-.033a9.181,9.181,0,0,0-3.571,1.269C191.947,386.431,189,387.91,185.538,386.191Z",
    transform: "translate(-77.851 -276.844)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M186.5,308.287V294h43.157v14.266c-5.482,3.365-9.482-1.841-12.848-1.863-3.344-.021-4.932,2.963-8.763,2.963-3.831.021-5.418-2.984-8.763-2.963S191.961,311.589,186.5,308.287Z",
    transform: "translate(-79.228 -206.467)",
    fill: "#e30016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M224.631,308.462a12.408,12.408,0,0,1-5.524-1.728,9.024,9.024,0,0,0-3.571-1.261H215.5a7.554,7.554,0,0,0-3.872,1.359,8.166,8.166,0,0,1-9.72,0,7.516,7.516,0,0,0-3.863-1.361h-.033a9,9,0,0,0-3.557,1.256c-2.522,1.267-5.661,2.843-9.406.579l-.165-.1V292.387h43.84v14.8l-.163.1A7.383,7.383,0,0,1,224.631,308.462ZM215.5,304.79h.037a9.439,9.439,0,0,1,3.874,1.334c2.47,1.241,5.264,2.645,8.63.677V293.07H185.57V306.82c3.348,1.926,6.126.532,8.581-.7a9.414,9.414,0,0,1,3.859-1.329,8.141,8.141,0,0,1,4.241,1.452,8.534,8.534,0,0,0,4.483,1.511h.038a8.607,8.607,0,0,0,4.517-1.514A8.2,8.2,0,0,1,215.5,304.79Z",
    transform: "translate(-77.957 -205.195)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M186.5,368.015v-2.032c5.461,3.323,9.461-1.841,12.805-1.884,3.365-.021,4.932,2.963,8.763,2.963s5.418-2.984,8.763-2.963,7.366,5.228,12.848,1.841v2.053c-5.482,3.365-9.482-1.82-12.848-1.841-3.344-.042-4.932,2.963-8.763,2.963s-5.4-3.006-8.763-2.963C195.982,366.174,191.961,371.338,186.5,368.015Z",
    transform: "translate(-79.228 -261.729)",
    fill: "#0081c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M188.962,368.194a7.387,7.387,0,0,1-3.911-1.159l-.164-.1V364.1l.519.316c3.432,2.088,6.274.66,8.781-.6a9.511,9.511,0,0,1,3.842-1.333h.037a8.194,8.194,0,0,1,4.23,1.453,7.476,7.476,0,0,0,9.015,0,8.2,8.2,0,0,1,4.213-1.45h.037a9.416,9.416,0,0,1,3.85,1.326c2.517,1.263,5.37,2.695,8.816.567l.521-.322v2.856l-.163.1c-3.764,2.311-6.922.732-9.46-.537a9.047,9.047,0,0,0-3.568-1.254h-.065a7.5,7.5,0,0,0-3.85,1.357,8.093,8.093,0,0,1-9.677,0,7.5,7.5,0,0,0-3.861-1.36h-.065a9,9,0,0,0-3.54,1.247A12.487,12.487,0,0,1,188.962,368.194Zm-3.392-1.645c3.356,1.944,6.152.546,8.622-.69a9.419,9.419,0,0,1,3.839-1.319h.073a8.136,8.136,0,0,1,4.2,1.452,7.435,7.435,0,0,0,8.993,0,8.084,8.084,0,0,1,4.263-1.448,9.466,9.466,0,0,1,3.867,1.326c2.471,1.235,5.267,2.633,8.635.663v-1.27c-3.541,1.883-6.533.381-8.96-.836a9,9,0,0,0-3.548-1.253h-.033a7.551,7.551,0,0,0-3.872,1.359,8.133,8.133,0,0,1-9.7,0,7.551,7.551,0,0,0-3.886-1.362h-.033a9.1,9.1,0,0,0-3.542,1.26c-2.417,1.215-5.4,2.713-8.924.868Z",
    transform: "translate(-77.957 -260.457)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M208.089,355.463c-3.81,0-5.4-2.984-8.741-2.963s-7.366,5.228-12.848,1.82v2.434c5.482,3.408,9.482-1.8,12.848-1.841,3.344-.021,4.932,2.963,8.741,2.963,3.831.021,5.4-2.984,8.741-2.963s7.366,5.228,12.848,1.841V354.32c-5.482,3.408-9.482-1.8-12.848-1.82C213.486,352.5,211.9,355.463,208.089,355.463Z",
    transform: "translate(-79.228 -252.585)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M189.015,356.974a7.377,7.377,0,0,1-3.967-1.2l-.161-.1v-3.238l.522.324c3.448,2.143,6.3.713,8.82-.549a9.4,9.4,0,0,1,3.845-1.322,8.122,8.122,0,0,1,4.253,1.453,7.416,7.416,0,0,0,8.966,0,8.2,8.2,0,0,1,4.268-1.456,9.432,9.432,0,0,1,3.863,1.326c2.512,1.259,5.359,2.686,8.8.545l.522-.324v3.239l-.162.1c-3.769,2.329-6.936.74-9.481-.537a8.992,8.992,0,0,0-3.548-1.253h-.033a7.466,7.466,0,0,0-3.852,1.36,9.033,9.033,0,0,1-4.814,1.6h-.043a9.028,9.028,0,0,1-4.806-1.6,7.388,7.388,0,0,0-3.929-1.362,9.074,9.074,0,0,0-3.549,1.262A12.381,12.381,0,0,1,189.015,356.974Zm-3.445-1.684c3.377,2,6.178.591,8.654-.655a9.5,9.5,0,0,1,3.848-1.335,8.125,8.125,0,0,1,4.281,1.454,8.476,8.476,0,0,0,4.465,1.509h.038a8.479,8.479,0,0,0,4.474-1.511,8.109,8.109,0,0,1,4.2-1.452h.037a9.414,9.414,0,0,1,3.85,1.326c2.478,1.243,5.28,2.65,8.654.664V353.64c-3.54,1.894-6.526.4-8.948-.816a9.015,9.015,0,0,0-3.561-1.254h-.033a7.54,7.54,0,0,0-3.889,1.365,8.074,8.074,0,0,1-9.649,0,7.543,7.543,0,0,0-3.875-1.362h-.033a8.991,8.991,0,0,0-3.543,1.25c-2.428,1.217-5.422,2.717-8.965.821Z",
    transform: "translate(-77.957 -251.313)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M236.623,227.006l.55-1.46-.339-.847.847-3.09.847-.466.318-1.228-.677-.339,1.4-4.656.825-.36.571-1.672-1.1-.423-.127.3-.487-.148.063-.317-.889-.317-.148.339-.529-.212.106-.317-1.4-.4-.889.064-.444,1.714.254.677-.127.571-2.138-.423.063-1.037.847-.487.339-1.8-1.164-.148-.085.3-.487-.085.021-.36-.974-.212-.064.36-.466-.064.042-.423-1.63-.275-.825.275-.085,1.63.233.55-.085.889a17.616,17.616,0,0,0-3.408-.254l-.317-1.122.677-.593V209.1h-1.185l-.021.36h-.55l.021-.36h-1.5l.021.36h-.466l-.021-.36h-1.185v2.032l.677.593-.317,1.122a17.616,17.616,0,0,0-3.408.254l-.085-.889.233-.55-.085-1.63-.825-.275-1.609.275.021.423-.466.064-.064-.36-.974.212.021.36-.466.085-.106-.3-1.164.148.339,1.8.847.487.064,1.037-2.138.423-.106-.571.233-.677-.423-1.714-.889-.064-1.4.4.106.317-.508.212-.148-.339-.889.317.063.317-.487.148-.106-.3-1.1.423.571,1.672.825.36,1.4,4.656-.656.339.3,1.228.847.466.847,3.09-.339.847.55,1.46Z",
    transform: "translate(-94.365 -139.537)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M235.475,226.223H208.494l-.66-1.751.344-.861-.789-2.88-.851-.468-.379-1.57.645-.333-1.29-4.3-.82-.357-.7-2.054,1.634-.629.053.148-.026-.13,1.376-.491.142.326h0l-.116-.348,1.734-.5,1.148.082.494,2-.236.686.039.211,1.606-.318-.039-.632-.827-.476-.42-2.229,1.7-.216.071.2-.015-.262,1.485-.323v-.028l1.931-.33,1.08.36.1,1.892-.23.544.048.51a17.6,17.6,0,0,1,2.934-.211l.208-.734-.639-.559v-2.45h5.465v2.45l-.639.559.208.734a17.85,17.85,0,0,1,2.934.211l.048-.51-.23-.544.1-1.892,1.08-.36,1.965.332,0,.033,1.452.316-.015.253.055-.192,1.712.218-.419,2.229-.827.476-.039.632,1.616.32.047-.214-.256-.682.519-2,1.146-.082,1.734.5-.115.345.019.008.144-.329,1.376.491-.052.261.116-.272,1.617.622-.7,2.054-.819.357-1.289,4.3.669.335-.407,1.573-.849.467-.789,2.88.344.861Zm-26.584-.575h26.186l.441-1.17-.333-.832.9-3.3.845-.465.228-.882-.686-.343,1.5-5.016.831-.362.441-1.29-.584-.225-.119.279-.983-.3.066-.33-.4-.144-.152.348-1.039-.416.1-.29-1.06-.3-.632.045-.37,1.427.252.672-.207.929-2.66-.527.088-1.442.866-.5.258-1.369-.616-.079-.088.308-.994-.173.022-.37-.441-.1-.06.337-1.014-.138.043-.432-1.294-.218-.571.19-.071,1.368.235.556-.121,1.27-.306-.052a17.339,17.339,0,0,0-3.353-.25l-.222,0-.428-1.51.716-.626v-1.614h-.627l-.021.36h-1.127l.021-.36h-.893l.021.36h-1.042l-.021-.36H219.8v1.614l.716.626-.428,1.51-.222,0a17.3,17.3,0,0,0-3.353.25l-.306.052-.121-1.27.236-.556-.071-1.368-.571-.19-1.286.22.022.432-1,.136-.06-.337-.441.1.022.368-.956.174-.11-.309-.632.081.258,1.369.866.5.088,1.442-2.67.529-.173-.932.23-.669-.353-1.429-.629-.045-1.06.3.1.287-1.016.423-.154-.352-.4.144.066.33-1,.3-.1-.277-.567.218.441,1.29.831.362,1.5,5.013-.668.345.214.885.842.463.9,3.3-.333.832Z",
    transform: "translate(-93.018 -138.466)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M251,238.947c-.191-.952.677-1.1.889-.148l.36,1.714-.889.169Z",
    transform: "translate(-130.054 -162.442)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M222.525,246.238c-.254-.931.593-1.164.868-.212l.466,1.693-.868.233Z",
    transform: "translate(-107.592 -168.167)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M266.8,259.227l.952-.127.339,2.392-.974.127Z",
    transform: "translate(-142.532 -178.954)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M235.4,266.512l.8-.212.55,1.968-.783.233Z",
    transform: "translate(-117.778 -184.63)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 0.288,
    height: 1.607,
    transform: "translate(121.249 81.914) rotate(-12.935)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 0.288,
    height: 1.611,
    transform: "translate(119.025 84.785) rotate(-9.831)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M228.269,227.464l-1.575-4.874.043-.577-.4-1.608.279-.069.408,1.652-.042.566,1.558,4.82Z",
    transform: "translate(-110.636 -148.396)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M259.383,220.284l-.955-5.148v-.762l-.105-1.6.287-.019.106,1.609v.758l.95,5.109Z",
    transform: "translate(-135.849 -142.418)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 4.346,
    height: 0.288,
    transform: "translate(125.779 77.598) rotate(-78.222)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 0.288,
    height: 4.282,
    transform: "translate(119.005 74.443) rotate(-13.143)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M232.734,238.665l-.287-.014.122-2.572-.759-.369-.27-1.1.279-.068.238.972.808.393Z",
    transform: "translate(-114.736 -159.591)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 0.288,
    height: 1.601,
    transform: "matrix(0.991, -0.132, 0.132, 0.991, 125.289, 83.679)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 0.287,
    height: 1.047,
    transform: "translate(117.715 81.218) rotate(-14.039)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 0.288,
    height: 1.003,
    transform: "matrix(0.992, -0.127, 0.127, 0.992, 124.506, 79.847)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2.218,
    height: 0.288,
    transform: "matrix(0.973, -0.229, 0.229, 0.973, 117.187, 75.879)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1.504,
    height: 0.288,
    transform: "translate(117.947 76.239) rotate(-13.847)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 1.594,
    height: 0.288,
    transform: "matrix(0.983, -0.186, 0.186, 0.983, 117.955, 76.746)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M236.809,243.7l-.067-.28,1.863-.445,3.666-.742.057.282-3.662.741Z",
    transform: "translate(-118.837 -165.658)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 3.827,
    height: 0.288,
    transform: "translate(119.539 76.45) rotate(-11.819)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 3.794,
    height: 0.288,
    transform: "matrix(0.982, -0.19, 0.19, 0.982, 119.351, 75.37)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 3.873,
    height: 0.288,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 119.031, 74.312)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 3.823,
    height: 0.287,
    transform: "translate(118.926 73.253) rotate(-11.488)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 4.654,
    height: 0.287,
    transform: "matrix(0.978, -0.209, 0.209, 0.978, 118.184, 72.809)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 4.695,
    height: 0.288,
    transform: "matrix(0.978, -0.207, 0.207, 0.978, 117.994, 72.004)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 4.658,
    height: 0.288,
    transform: "translate(111.544 74.104) rotate(-18.266)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 4.551,
    height: 0.288,
    transform: "matrix(0.949, -0.316, 0.316, 0.949, 111.84, 74.93)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 3.661,
    height: 0.288,
    transform: "translate(112.623 75.205) rotate(-18.526)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 3.695,
    height: 0.288,
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 112.899, 76.03)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 3.692,
    height: 0.288,
    transform: "translate(113.202 77.002) rotate(-15.634)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 3.704,
    height: 0.287,
    transform: "translate(113.56 78.039) rotate(-16.245)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 3.57,
    height: 0.288,
    transform: "matrix(0.96, -0.279, 0.279, 0.96, 113.941, 78.971)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 0.288,
    height: 1.053,
    transform: "translate(114.393 75.675) rotate(-15.156)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 0.287,
    height: 1.047,
    transform: "translate(115.577 76.435) rotate(-14.038)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 0.288,
    height: 1.068,
    transform: "translate(114.053 76.921) rotate(-13.758)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 0.287,
    height: 0.77,
    transform: "translate(113.504 75.063) rotate(-15.945)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 0.287,
    height: 0.785,
    transform: "translate(114.794 74.678) rotate(-14.034)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 0.288,
    height: 0.552,
    transform: "translate(116.192 74.427) rotate(-85.596)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 0.287,
    height: 0.895,
    transform: "translate(116.187 73.77) rotate(-83.211)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 0.287,
    height: 0.416,
    transform: "matrix(0.967, -0.254, 0.254, 0.967, 112.339, 73.452)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 0.288,
    height: 0.402,
    transform: "translate(112.892 73.292) rotate(-18.426)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 0.287,
    height: 0.37,
    transform: "matrix(0.973, -0.229, 0.229, 0.973, 113.926, 72.962)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 0.288,
    height: 0.489,
    transform: "translate(114.31 72.761) rotate(-17.642)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 0.288,
    height: 0.473,
    transform: "translate(118.962 71.409) rotate(-10.304)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 0.287,
    height: 0.512,
    transform: "matrix(0.992, -0.124, 0.124, 0.992, 119.511, 71.232)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 0.288,
    height: 0.585,
    transform: "translate(120.444 70.97) rotate(-12.532)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 0.287,
    height: 0.422,
    transform: "translate(120.956 70.982) rotate(-17.529)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 0.287,
    height: 0.727,
    transform: "matrix(0.145, -0.989, 0.989, 0.145, 122.617, 72.796)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 0.288,
    height: 0.934,
    transform: "translate(122.669 72.159) rotate(-76.909)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M262.881,232.161l-.282-.056.531-2.694-.809-.477V227.9h.288v.87l.842.5Z",
    transform: "translate(-139.001 -154.357)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 0.288,
    height: 1.114,
    transform: "translate(119.913 73.162) rotate(-8.749)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 0.288,
    height: 1.03,
    transform: "matrix(0.986, -0.164, 0.164, 0.986, 121.311, 72.889)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 0.287,
    height: 1.075,
    transform: "translate(120.761 74.097) rotate(-10.203)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 0.287,
    height: 0.992,
    transform: "translate(120.211 75.39) rotate(-11.075)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 0.288,
    height: 0.971,
    transform: "translate(121.862 75.052) rotate(-11.309)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 2.966,
    height: 0.288,
    transform: "translate(123.542 74.415) rotate(-2.472)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 2.332,
    height: 0.288,
    transform: "translate(124.112 74.838) rotate(-3.132)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 2.163,
    height: 0.288,
    transform: "translate(124.174 75.495) rotate(-3.379)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M265.562,240.962l-.028-.286,2.18-.212,2.276-.043.005.288-2.265.042Z",
    transform: "translate(-141.535 -164.228)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 1.905,
    height: 0.288,
    transform: "translate(126.425 75.282) rotate(-0.618)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 2.159,
    height: 0.288,
    transform: "translate(126.638 74.224)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 2.116,
    height: 0.288,
    transform: "translate(126.871 73.187)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 1.926,
    height: 0.288,
    transform: "translate(127.083 72.023)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 0.288,
    height: 0.677,
    transform: "translate(127.468 70.029)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 0.288,
    height: 0.571,
    transform: "translate(128.145 69.987)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 0.288,
    height: 1.058,
    transform: "translate(127.807 72.209)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1.009,
    height: 0.287,
    transform: "translate(127.237 75.381) rotate(-80.355)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M322.07,238.947c.212-.952-.677-1.1-.889-.148l-.381,1.714.889.169Z",
    transform: "translate(-185.103 -162.442)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M350.333,246.238c.275-.931-.593-1.164-.868-.212L349,247.72l.868.233Z",
    transform: "translate(-207.334 -168.167)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M306.391,259.227l-.974-.127-.317,2.392.974.127Z",
    transform: "translate(-172.726 -178.954)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M337.476,266.512l-.825-.212-.55,1.968.8.233Z",
    transform: "translate(-197.165 -184.63)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 1.612,
    height: 0.288,
    transform: "matrix(0.236, -0.972, 0.972, 0.236, 136.023, 83.414)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.611,
    height: 0.287,
    transform: "translate(138.349 86.323) rotate(-80.145)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M341.427,227.464l-.274-.088,1.558-4.823-.021-.566,0-.02.4-1.63.279.069-.4,1.61.022.577Z",
    transform: "translate(-201.148 -148.396)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M313.515,220.277l-.283-.053.95-5.109v-.749l.127-1.62.286.023-.127,1.609v.764l0,.013Z",
    transform: "translate(-179.137 -142.411)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 0.288,
    height: 4.346,
    transform: "matrix(0.979, -0.205, 0.205, 0.979, 130.963, 73.403)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 4.282,
    height: 0.287,
    transform: "translate(137.674 78.547) rotate(-76.863)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M340.231,238.665,340.1,235.9l.808-.393.238-.972.279.068-.27,1.1-.759.369.123,2.572Z",
    transform: "translate(-200.318 -159.591)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 1.599,
    height: 0.288,
    transform: "translate(132.146 85.23) rotate(-83.151)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 1.042,
    height: 0.288,
    transform: "translate(139.684 82.167) rotate(-77.083)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 1.003,
    height: 0.288,
    transform: "translate(133.015 80.805) rotate(-82.732)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 0.288,
    height: 2.238,
    transform: "matrix(0.227, -0.974, 0.974, 0.227, 138.501, 75.651)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 0.288,
    height: 1.504,
    transform: "matrix(0.239, -0.971, 0.971, 0.239, 138.457, 76.158)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 0.288,
    height: 1.594,
    transform: "translate(138.358 76.732) rotate(-79.285)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M320.285,243.7l-1.841-.445-3.677-.74.057-.282,3.683.741,1.847.446Z",
    transform: "translate(-180.347 -165.658)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 0.288,
    height: 3.827,
    transform: "matrix(0.205, -0.979, 0.979, 0.205, 134.588, 75.948)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 0.288,
    height: 3.794,
    transform: "translate(134.781 74.932) rotate(-79.065)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 0.288,
    height: 3.873,
    transform: "translate(135.032 73.789) rotate(-78.014)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 0.288,
    height: 3.823,
    transform: "translate(135.203 72.773) rotate(-78.503)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 0.288,
    height: 4.633,
    transform: "matrix(0.21, -0.978, 0.978, 0.21, 135.138, 72.117)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 0.287,
    height: 4.674,
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 135.286, 71.312)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 0.288,
    height: 4.658,
    transform: "translate(141.875 72.917) rotate(-71.728)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 0.287,
    height: 4.571,
    transform: "translate(141.663 73.763) rotate(-71.648)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 0.288,
    height: 3.661,
    transform: "matrix(0.318, -0.948, 0.948, 0.318, 141.726, 74.314)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 0.288,
    height: 3.695,
    transform: "matrix(0.309, -0.951, 0.951, 0.309, 141.431, 75.161)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 0.287,
    height: 3.672,
    transform: "matrix(0.271, -0.963, 0.963, 0.271, 141.098, 76.284)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 0.287,
    height: 3.704,
    transform: "translate(140.737 77.279) rotate(-73.74)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 0.288,
    height: 3.57,
    transform: "translate(140.483 78.252) rotate(-73.821)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 1.047,
    height: 0.288,
    transform: "translate(142.987 76.619) rotate(-75.984)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 1.042,
    height: 0.288,
    transform: "matrix(0.224, -0.975, 0.975, 0.224, 141.822, 77.384)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 1.063,
    height: 0.288,
    transform: "translate(143.346 77.892) rotate(-77.342)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 0.777,
    height: 0.287,
    transform: "translate(143.92 75.722) rotate(-72.543)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 0.785,
    height: 0.288,
    transform: "translate(142.669 75.37) rotate(-75.984)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 0.552,
    height: 0.288,
    transform: "translate(141.147 74.182) rotate(-4.37)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 0.895,
    height: 0.287,
    transform: "translate(140.802 73.59) rotate(-6.772)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 0.416,
    height: 0.288,
    transform: "matrix(0.254, -0.967, 0.967, 0.254, 145.188, 73.781)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 0.402,
    height: 0.288,
    transform: "matrix(0.316, -0.949, 0.949, 0.316, 144.62, 73.582)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 0.365,
    height: 0.288,
    transform: "translate(143.641 73.263) rotate(-79.982)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 0.489,
    height: 0.288,
    transform: "translate(143.201 73.139) rotate(-72.386)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 0.477,
    height: 0.287,
    transform: "matrix(0.221, -0.975, 0.975, 0.221, 138.584, 71.817)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 0.515,
    height: 0.288,
    transform: "translate(138.053 71.698) rotate(-80.524)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 0.585,
    height: 0.288,
    transform: "translate(137.059 71.479) rotate(-77.462)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 0.422,
    height: 0.287,
    transform: "translate(136.576 71.298) rotate(-72.464)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 0.727,
    height: 0.287,
    transform: "translate(134.533 72.617) rotate(-8.352)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 0.934,
    height: 0.288,
    transform: "matrix(0.974, -0.227, 0.227, 0.974, 134.289, 72.09)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M310.91,232.161l-.57-2.894.843-.5v-.87h.288v1.035l-.809.477.531,2.694Z",
    transform: "translate(-176.857 -154.357)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 1.117,
    height: 0.287,
    transform: "translate(137.545 74.216) rotate(-80.185)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 1.03,
    height: 0.288,
    transform: "translate(136.148 73.857) rotate(-80.524)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 1.072,
    height: 0.288,
    transform: "translate(136.698 75.107) rotate(-80.903)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 0.992,
    height: 0.288,
    transform: "matrix(0.192, -0.981, 0.981, 0.192, 137.249, 76.309)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 0.971,
    height: 0.288,
    transform: "translate(135.598 75.948) rotate(-78.682)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 0.288,
    height: 2.945,
    transform: "translate(131.415 74.575) rotate(-87.528)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 0.288,
    height: 2.332,
    transform: "translate(131.456 74.998) rotate(-86.877)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 0.288,
    height: 2.141,
    transform: "translate(131.582 75.654) rotate(-86.602)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M295.721,240.962l-2.18-.212-2.254-.042.005-.288,2.265.042,2.191.212Z",
    transform: "translate(-161.837 -164.228)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 0.288,
    height: 1.926,
    transform: "translate(129.579 75.549) rotate(-89.373)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 2.159,
    height: 0.288,
    transform: "translate(129.136 74.224)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 2.117,
    height: 0.288,
    transform: "translate(128.945 73.187)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 1.926,
    height: 0.288,
    transform: "translate(128.903 72.023)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 0.288,
    height: 0.677,
    transform: "translate(130.156 70.029)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 0.288,
    height: 0.571,
    transform: "translate(129.5 69.987)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 0.288,
    height: 1.058,
    transform: "translate(129.838 72.209)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 0.288,
    height: 1.006,
    transform: "translate(130.242 74.431) rotate(-8.473)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M286.083,231.4a.763.763,0,0,1,.783.847v2.286H285.3v-2.286A.752.752,0,0,1,286.083,231.4Z",
    transform: "translate(-157.117 -157.117)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 0.288,
    height: 4.17,
    transform: "translate(128.844 73.267)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 4.91,
    height: 0.288,
    transform: "translate(126.511 70.478)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 4.974,
    height: 0.288,
    transform: "translate(126.469 71.388)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M240.4,287.124a32.436,32.436,0,0,1,10.265-1.524,33.42,33.42,0,0,1,10.308,1.524Z",
    transform: "translate(-121.72 -199.845)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M258.96,286.789H236.887l.7-.239a32.622,32.622,0,0,1,10.3-1.53,33.741,33.741,0,0,1,10.35,1.53Zm-20.551-.246h19a34.775,34.775,0,0,0-9.518-1.278A33.663,33.663,0,0,0,238.409,286.544Z",
    transform: "translate(-118.951 -199.388)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M252.685,284.51c-5.657-1.677-8.985-2.257-13.189-2.3-4.217.044-7.551.624-13.207,2.3l-.082-.276c5.686-1.685,9.039-2.269,13.289-2.313,4.238.044,7.586.628,13.271,2.313Z",
    transform: "translate(-110.531 -196.945)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M251.357,276.437c-5.986-1.8-9.309-2.386-13.675-2.428-4.379.042-7.707.632-13.694,2.428l-.083-.275c6.016-1.8,9.363-2.4,13.776-2.44,4.346.042,7.817.658,13.758,2.44Z",
    transform: "translate(-108.716 -190.48)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M224.889,273.215l-.082-.276c5.958-1.766,9.386-2.376,13.585-2.419,4.275.043,7.7.653,13.589,2.419l-.083.275c-5.857-1.757-9.265-2.364-13.506-2.407C234.226,270.851,230.818,271.458,224.889,273.215Z",
    transform: "translate(-109.428 -187.958)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M250.744,265.442c-6.019-1.806-9.794-2.492-13.93-2.534-4.132.041-7.908.728-13.927,2.534l-.083-.275c6.047-1.814,9.844-2.5,14.009-2.546,4.168.041,7.965.732,14.012,2.546Z",
    transform: "translate(-107.849 -181.73)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M249.784,258.069c-6.185-1.849-10.331-2.62-14.311-2.661-3.931.041-8.2.836-14.286,2.661l-.083-.275c6.109-1.833,10.407-2.632,14.369-2.673,4.011.041,8.18.816,14.393,2.673Z",
    transform: "translate(-106.508 -175.817)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M247.2,254.081c-6.31-1.893-11.289-2.833-15.22-2.873-3.915.04-8.887.98-15.2,2.873l-.083-.275c6.336-1.9,11.334-2.844,15.279-2.885,3.962.04,8.967.984,15.3,2.885Z",
    transform: "translate(-103.04 -172.506)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M248.093,248.591a56.481,56.481,0,0,0-14.9-2.682,56.485,56.485,0,0,0-14.9,2.682l-.082-.276a56.756,56.756,0,0,1,14.982-2.694,56.756,56.756,0,0,1,14.986,2.694Z",
    transform: "translate(-104.224 -168.328)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M287.6,429.7l.021,15.557a5.2,5.2,0,0,0,1.5,1.968,2.474,2.474,0,0,1-.233-2.117,2.784,2.784,0,0,0,1.566,2.053,3.446,3.446,0,0,1-.317-2.053,2.31,2.31,0,0,0,1.587,2.053,3.054,3.054,0,0,1-.656-2.413c.444,1.122.868,2.286,1.714,2.434a3.031,3.031,0,0,1-.508-2.053c.677,1.291.931,1.651,1.757,1.757-.529-.656-.127-1.185-.614-2.5-.55-1.5-2.1-1.63-3.26-2.5-.423-.317-.4-1.185-.593-1.757a2.668,2.668,0,0,0,1.778,1.63,2.708,2.708,0,0,1-.614-2.159,4.89,4.89,0,0,0,1.418,2.244,3.835,3.835,0,0,1-.444-2.222c.275,1.1.677,1.9,1.333,2.117-.3-.423-.233-1.482-.72-2.54-.593-1.333-2.138-1.714-3.006-3.027a8.529,8.529,0,0,1-.677-1.63c.36.783.677,1.672,1.333,1.841a6.539,6.539,0,0,0,.148-2.053c.021,1.778.317,2.1,1.46,2.455a3.4,3.4,0,0,1-.868-2.1,8.92,8.92,0,0,0,1.5,2.5c-.36-.847-.36-1.99-.741-2.794a10.851,10.851,0,0,0-2.413-2.836A5.957,5.957,0,0,1,287.6,429.7Z",
    transform: "translate(-158.93 -313.445)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M288.655,446.883a.124.124,0,0,1-.079-.028,5.332,5.332,0,0,1-1.539-2.015.129.129,0,0,1-.011-.051l-.021-15.557a.126.126,0,0,1,.235-.063A5.827,5.827,0,0,0,288.672,431c.223.227.431.427.633.621a7.964,7.964,0,0,1,1.811,2.255,6.154,6.154,0,0,1,.4,1.465,6.676,6.676,0,0,0,.345,1.337.126.126,0,0,1-.209.134,6.151,6.151,0,0,1-.42-.516.126.126,0,0,1-.012.09.124.124,0,0,1-.148.059c-.725-.228-1.132-.451-1.345-1a4.683,4.683,0,0,1-.1.508.126.126,0,0,1-.153.089,1.049,1.049,0,0,1-.343-.16,6.548,6.548,0,0,0,1.275,1.138,4.344,4.344,0,0,1,1.564,1.664,6.578,6.578,0,0,1,.458,1.635,2.6,2.6,0,0,0,.25.884.126.126,0,0,1-.142.192A2.058,2.058,0,0,1,291.364,440a4.408,4.408,0,0,0,.431,1.324.126.126,0,0,1-.189.155,4.274,4.274,0,0,1-1.223-1.714,2.383,2.383,0,0,0,.589,1.447.126.126,0,0,1,.013.147.123.123,0,0,1-.136.058,2.481,2.481,0,0,1-1.459-1.014,1.515,1.515,0,0,0,.378.917,7.282,7.282,0,0,0,1.217.686,3.479,3.479,0,0,1,2.085,1.87,4.757,4.757,0,0,1,.295,1.473,1.534,1.534,0,0,0,.3.989.126.126,0,0,1,.012.14.128.128,0,0,1-.126.064c-.792-.1-1.1-.448-1.605-1.361a2.46,2.46,0,0,0,.468,1.451.126.126,0,0,1-.118.205c-.754-.132-1.188-.978-1.567-1.9a2.522,2.522,0,0,0,.621,1.671.126.126,0,0,1,.017.151.125.125,0,0,1-.14.058,2.12,2.12,0,0,1-1.452-1.372,2.889,2.889,0,0,0,.324,1.191.126.126,0,0,1-.162.174,2.706,2.706,0,0,1-1.479-1.63,1.978,1.978,0,0,0,.294,1.5.126.126,0,0,1-.1.205Zm1.947-2.728a.126.126,0,0,1,.117.08l.058.148a4.528,4.528,0,0,0,1.215,2.071,3.764,3.764,0,0,1-.31-1.794.126.126,0,0,1,.237-.056c.581,1.108.835,1.49,1.377,1.637a2.1,2.1,0,0,1-.185-.872,4.535,4.535,0,0,0-.28-1.4,3.24,3.24,0,0,0-1.958-1.73,7.478,7.478,0,0,1-1.258-.711,1.893,1.893,0,0,1-.5-1.208,4.6,4.6,0,0,0-.138-.61.126.126,0,0,1,.233-.094,2.756,2.756,0,0,0,1.323,1.44,2.969,2.969,0,0,1-.4-1.926.126.126,0,0,1,.243-.033,6,6,0,0,0,.944,1.768,3.586,3.586,0,0,1-.213-1.72.126.126,0,0,1,.247-.014,3.286,3.286,0,0,0,.953,1.874,6.306,6.306,0,0,1-.136-.637,6.4,6.4,0,0,0-.44-1.576,4.156,4.156,0,0,0-1.485-1.566,5.9,5.9,0,0,1-1.511-1.444,4.819,4.819,0,0,1-.509-1.153c-.059-.171-.116-.341-.18-.5a.126.126,0,0,1,.231-.1c.043.094.086.189.128.285.273.612.555,1.243,1,1.445a5.746,5.746,0,0,0,.13-1.341c-.01-.166-.016-.348-.019-.547a.126.126,0,0,1,.252-.009c.011.195.018.379.019.555.063,1.015.294,1.366.9,1.624a4.648,4.648,0,0,1-.573-1.79.126.126,0,0,1,.239-.072,10.2,10.2,0,0,0,1.064,1.948c-.06-.243-.107-.494-.153-.74a5.961,5.961,0,0,0-.378-1.4,7.65,7.65,0,0,0-1.759-2.185c-.2-.195-.414-.4-.63-.618a5.324,5.324,0,0,1-1.244-1.488l.021,15.067a5.191,5.191,0,0,0,.98,1.462,3.535,3.535,0,0,1,.041-1.61.126.126,0,0,1,.121-.1.122.122,0,0,1,.124.095,2.744,2.744,0,0,0,1.179,1.8,3.824,3.824,0,0,1-.177-1.786.126.126,0,0,1,.119-.112.129.129,0,0,1,.129.1,2.422,2.422,0,0,0,1.091,1.8,3.653,3.653,0,0,1-.409-2.141.126.126,0,0,1,.105-.118Zm.018-8.847a2.008,2.008,0,0,0,.554.9A8.608,8.608,0,0,1,290.62,435.308Z",
    transform: "translate(-158.461 -312.977)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 0.21,
    height: 0.704,
    transform: "translate(129.377 120.653) rotate(-21.145)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M291.1,502.068a2.847,2.847,0,0,1-.69-2.744l.122.032a2.732,2.732,0,0,0,.665,2.632Z",
    transform: "translate(-161.056 -368.333)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M296.479,502.774a3.815,3.815,0,0,1-1.076-2.581l.126-.005a3.693,3.693,0,0,0,1.041,2.5Z",
    transform: "translate(-165.081 -369.014)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M298.188,502.674a3.027,3.027,0,0,1-.407-2.462l.12.037a2.914,2.914,0,0,0,.4,2.364Z",
    transform: "translate(-166.864 -369.033)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M302.3,502.626a3.286,3.286,0,0,1-1-2.436l.126-.008a3.169,3.169,0,0,0,.951,2.347Z",
    transform: "translate(-169.733 -369.009)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M307.39,503.138a4.277,4.277,0,0,1-.987-2.447l.126-.007a4.1,4.1,0,0,0,.96,2.378Z",
    transform: "translate(-173.753 -369.404)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M302.339,474.516c-.033-.217-.077-.41-.12-.6s-.081-.351-.113-.547l.124-.019c.03.191.069.36.111.538s.089.383.122.605Z",
    transform: "translate(-170.366 -347.859)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M303.774,476.15a10.431,10.431,0,0,0-.258-1.142c-.076-.29-.154-.59-.207-.843l.123-.026c.052.25.13.548.205.837a10.5,10.5,0,0,1,.261,1.158Z",
    transform: "translate(-171.314 -348.479)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M305.537,478.22a5.252,5.252,0,0,1-.449-2.037l.126.007a5.151,5.151,0,0,0,.44,1.984Z",
    transform: "translate(-172.714 -350.09)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M309.346,478.6a4.007,4.007,0,0,1-.84-2.128l.124-.018a3.892,3.892,0,0,0,.811,2.063Z",
    transform: "translate(-175.411 -350.307)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M299.486,477.5a4.282,4.282,0,0,1-1.179-2.317l.124-.021a4.177,4.177,0,0,0,.287.987,1.938,1.938,0,0,1,.013-1.036l.121.035a2.41,2.41,0,0,0,.728,2.27Z",
    transform: "translate(-167.371 -349.249)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M295.954,453.773a4.54,4.54,0,0,1-.556-2.082l.126,0a4.427,4.427,0,0,0,.544,2.025Z",
    transform: "translate(-165.077 -330.782)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M301.623,455.659a2.692,2.692,0,0,1-1.122-2.166l.126,0a2.545,2.545,0,0,0,1.079,2.067Z",
    transform: "translate(-169.1 -332.202)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M305.258,456.674l-.1-.166a4.476,4.476,0,0,1-.758-2.02l.126-.009a4.311,4.311,0,0,0,.741,1.966l.1.166Z",
    transform: "translate(-172.176 -332.98)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M312.513,503.961a3.54,3.54,0,0,1-1.246-2l.1-.025a3.441,3.441,0,0,0,1.209,1.941Z",
    transform: "translate(-177.588 -370.395)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M314.285,504.384a2.994,2.994,0,0,1-.926-1.984h.1a2.887,2.887,0,0,0,.894,1.91Z",
    transform: "translate(-179.237 -370.758)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M269.888,431.8v16.784a7.178,7.178,0,0,1-4.487-3.006c-1.333-2.138.233-3.577.275-4.36.021-.3-.275-.571-.444-.847a1.406,1.406,0,0,0,1.757-1.27c.064-.741-.36-1.355-1.545-1.947a1.091,1.091,0,0,0,.635-.593,2.537,2.537,0,0,0-.063-1.037c-.148-1.418,1.185-2.455,3.217-3.408Z",
    transform: "translate(-141.007 -315.101)",
    fill: "#e30016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M269.485,447.888l-.187-.048a7.294,7.294,0,0,1-4.577-3.07,3.467,3.467,0,0,1-.018-3.717,2.388,2.388,0,0,0,.271-.732.939.939,0,0,0-.255-.521c-.059-.08-.118-.16-.167-.239l-.186-.3.346.078a1.293,1.293,0,0,0,1.05-.192,1.316,1.316,0,0,0,.525-.948c.06-.705-.391-1.26-1.463-1.8l-.351-.175.378-.1a.951.951,0,0,0,.532-.5,1.249,1.249,0,0,0-.017-.622c-.02-.111-.041-.228-.054-.352-.177-1.7,1.672-2.795,3.3-3.559l.869-.421ZM265,439.672a1.055,1.055,0,0,1,.276.668,2.525,2.525,0,0,1-.3.842,3.171,3.171,0,0,0,0,3.429,6.927,6.927,0,0,0,4.211,2.89V431.149l-.441.214c-2.291,1.074-3.257,2.078-3.134,3.257.012.117.032.226.051.331a1.5,1.5,0,0,1,.006.769,1.185,1.185,0,0,1-.45.548c1.011.562,1.435,1.173,1.368,1.957a1.613,1.613,0,0,1-.649,1.163A1.538,1.538,0,0,1,265,439.672Z",
    transform: "translate(-140.453 -314.211)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M283.781,397.043l.444-1.143v12.509h-.762l.36-5.08-.106-4.254c-.233-.317-.741-.55-.72-.931C283,397.7,283.506,397.424,283.781,397.043Z",
    transform: "translate(-155.301 -286.799)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M283.817,405.586h-1.072l.371-5.24-.1-4.191a2.336,2.336,0,0,0-.259-.25c-.225-.2-.48-.421-.462-.742a1.247,1.247,0,0,1,.5-.843,2.951,2.951,0,0,0,.3-.322l.727-1.868Zm-.751-.3h.451V393.726l-.174.432a2.974,2.974,0,0,1-.342.375c-.212.208-.413.4-.413.638-.01.184.17.342.36.509a2.2,2.2,0,0,1,.331.334l.028.038v.047l.106,4.254Z",
    transform: "translate(-154.743 -283.826)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M276.517,470.528c-.021.677.508,1.524.19,2.138a.53.53,0,0,1-.889.127c-.063-.106.021-.233.127-.3.169-.064.233.233.36.19.72-.19,0-1.333.021-2.1a.537.537,0,0,1,.55-.508c.4.064.423.233.318.381-.127.19-.275-.148-.444-.148C276.665,470.317,276.517,470.444,276.517,470.528Z",
    transform: "translate(-149.625 -345.278)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M276.119,472.919a.515.515,0,0,1-.406-.2.19.19,0,0,1,0-.19.362.362,0,0,1,.136-.142c.111-.042.182.041.239.106s.086.1.126.082a.375.375,0,0,0,.245-.171,1.567,1.567,0,0,0-.083-1.012,3.36,3.36,0,0,1-.157-.89.626.626,0,0,1,.232-.429.453.453,0,0,1,.346-.1c.211.034.339.1.379.195a.23.23,0,0,1-.046.224.134.134,0,0,1-.092.067c-.065.011-.125-.044-.189-.1a.333.333,0,0,0-.183-.106c-.076,0-.209.119-.209.188h0a3.154,3.154,0,0,0,.144.843,1.868,1.868,0,0,1,.044,1.3.6.6,0,0,1-.466.327A.512.512,0,0,1,276.119,472.919Zm-.214-.5a.108.108,0,0,0-.038.007c-.1.058-.168.173-.115.262a.467.467,0,0,0,.419.176.55.55,0,0,0,.428-.3,1.836,1.836,0,0,0-.048-1.271,3.182,3.182,0,0,1-.145-.856c0-.1.162-.235.257-.235a.361.361,0,0,1,.214.117c.056.048.106.092.151.088a.092.092,0,0,0,.059-.047.192.192,0,0,0,.041-.178c-.033-.078-.151-.136-.342-.166a.4.4,0,0,0-.309.092.579.579,0,0,0-.214.394,3.331,3.331,0,0,0,.156.876,1.583,1.583,0,0,1,.078,1.049.425.425,0,0,1-.273.193c-.072.024-.125-.037-.176-.1S275.955,472.424,275.9,472.424Z",
    transform: "translate(-149.537 -345.19)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M285.447,489.521l-.847-.021.4,2.307.423,5.905Z",
    transform: "translate(-156.565 -360.588)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M284.867,497.3a.15.15,0,0,1-.149-.139l-.423-5.905-.4-2.292a.149.149,0,0,1,.034-.123.154.154,0,0,1,.117-.052l.847.021a.15.15,0,0,1,.146.15l-.021,8.191a.15.15,0,0,1-.145.149Zm-.647-8.208.371,2.127.137,1.9.01-4.014Z",
    transform: "translate(-156.007 -360.031)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 0.126,
    height: 6.392,
    transform: "translate(128.163 121.991)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 0.15,
    height: 6.371,
    transform: "translate(128.362 122.075)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M208.089,376.663c-3.81,0-5.4-2.984-8.741-2.963s-7.366,5.228-12.848,1.82v2.434c5.482,3.408,9.482-1.8,12.848-1.841,3.344-.021,4.932,2.963,8.741,2.963,3.831.021,5.4-2.984,8.741-2.963s7.366,5.228,12.848,1.841V375.52c-5.482,3.408-9.482-1.8-12.848-1.82C213.486,373.678,211.9,376.663,208.089,376.663Z",
    transform: "translate(-79.228 -269.298)",
    fill: "#d9dadb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M189.015,378.175a7.377,7.377,0,0,1-3.967-1.2l-.161-.1v-3.238l.522.324c3.448,2.144,6.3.713,8.82-.549a9.406,9.406,0,0,1,3.845-1.322h.037a8.185,8.185,0,0,1,4.216,1.453,7.43,7.43,0,0,0,8.981,0,8.186,8.186,0,0,1,4.216-1.453h.037a9.432,9.432,0,0,1,3.863,1.326c2.512,1.259,5.359,2.686,8.8.545l.522-.324v3.239l-.162.1c-3.769,2.329-6.936.74-9.481-.537a9,9,0,0,0-3.548-1.253h-.032a7.464,7.464,0,0,0-3.852,1.361,9.034,9.034,0,0,1-4.814,1.6h-.043a9.113,9.113,0,0,1-4.83-1.6,7.543,7.543,0,0,0-3.875-1.362h-.033a9.084,9.084,0,0,0-3.547,1.262A12.377,12.377,0,0,1,189.015,378.175Zm-3.445-1.684c3.377,2,6.178.591,8.654-.655a9.5,9.5,0,0,1,3.848-1.336h.037a8.186,8.186,0,0,1,4.218,1.453,7.461,7.461,0,0,0,9,0,8.11,8.11,0,0,1,4.2-1.453h.037a9.416,9.416,0,0,1,3.85,1.326c2.478,1.243,5.281,2.65,8.654.664v-1.65c-3.54,1.894-6.526.4-8.948-.816a9.016,9.016,0,0,0-3.561-1.254h-.033a7.542,7.542,0,0,0-3.875,1.362,8.088,8.088,0,0,1-9.663,0,7.543,7.543,0,0,0-3.875-1.362h-.033a8.991,8.991,0,0,0-3.543,1.25c-2.428,1.217-5.422,2.717-8.965.821Z",
    transform: "translate(-77.957 -268.026)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M271.581,301.8l1.228,3.281,3.281-.825-2.222,2.709,2.349,2.413-3.471-.571-.91,3.259-1.228-3.281-3.281.825,2.222-2.709-2.349-2.434,3.471.593Z",
    transform: "translate(-142.848 -212.616)",
    fill: "#d7b369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M271.1,311.526a.2.2,0,0,1-.185-.128l-1.166-3.115-3.109.782a.2.2,0,0,1-.2-.317l2.111-2.573-2.227-2.307a.2.2,0,0,1,.175-.332l3.3.563.862-3.088a.2.2,0,0,1,.182-.144.191.191,0,0,1,.194.128l1.166,3.115,3.109-.782a.2.2,0,0,1,.2.317l-2.11,2.572,2.226,2.286a.2.2,0,0,1-.174.333l-3.3-.542-.863,3.089a.2.2,0,0,1-.182.144Zm-1.228-3.676a.2.2,0,0,1,.185.128l1.015,2.713.747-2.676a.2.2,0,0,1,.222-.142l2.878.474-1.93-1.982a.2.2,0,0,1-.011-.263l1.842-2.246-2.7.679a.2.2,0,0,1-.233-.122l-1.015-2.713-.747,2.676a.2.2,0,0,1-.224.142l-2.877-.491,1.931,2a.2.2,0,0,1,.011.263l-1.842,2.246,2.7-.679A.19.19,0,0,1,269.872,307.85Z",
    transform: "translate(-142.112 -211.879)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 0.678,
    height: 0.21,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 129.138, 92.42)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 0.648,
    height: 0.21,
    transform: "matrix(0.621, -0.784, 0.784, 0.621, 129.032, 91.997)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 0.572,
    height: 0.21,
    transform: "translate(128.948 91.552) rotate(-51.005)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 0.542,
    height: 0.21,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 128.842, 91.129)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 0.436,
    height: 0.21,
    transform: "matrix(0.63, -0.776, 0.776, 0.63, 128.758, 90.663)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 0.406,
    height: 0.21,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 128.652, 90.261)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 0.691,
    height: 0.209,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 127.955, 96.503)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 0.635,
    height: 0.21,
    transform: "translate(128.1 96.91) rotate(-53.175)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 0.572,
    height: 0.21,
    transform: "translate(128.25 97.288) rotate(-51.005)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.51,
    height: 0.21,
    transform: "translate(128.359 97.665) rotate(-48.357)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 0.47,
    height: 0.21,
    transform: "translate(128.5 98.075) rotate(-54.147)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 0.377,
    height: 0.21,
    transform: "matrix(0.617, -0.787, 0.787, 0.617, 128.651, 98.432)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 0.21,
    height: 0.692,
    transform: "matrix(0.918, -0.398, 0.398, 0.918, 130.013, 95.597)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 0.21,
    height: 0.645,
    transform: "matrix(0.919, -0.394, 0.394, 0.919, 130.457, 95.702)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 0.21,
    height: 0.578,
    transform: "translate(130.881 95.83) rotate(-23.742)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 0.21,
    height: 0.512,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 131.305, 95.937)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 0.21,
    height: 0.456,
    transform: "translate(131.747 96.059) rotate(-21.821)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 0.21,
    height: 0.389,
    transform: "matrix(0.925, -0.381, 0.381, 0.925, 132.171, 96.166)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.21,
    height: 0.683,
    transform: "matrix(0.124, -0.992, 0.992, 0.124, 130.583, 93.902)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 0.21,
    height: 0.644,
    transform: "translate(130.896 93.584) rotate(-80.538)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 0.21,
    height: 0.581,
    transform: "matrix(0.182, -0.983, 0.983, 0.182, 131.212, 93.266)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.21,
    height: 0.515,
    transform: "translate(131.531 92.97) rotate(-80.549)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.21,
    height: 0.449,
    transform: "translate(131.872 92.674) rotate(-81.877)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.21,
    height: 0.411,
    transform: "translate(132.183 92.355) rotate(-78.102)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 0.21,
    height: 0.684,
    transform: "translate(127.218 92.525) rotate(-21.797)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 0.21,
    height: 0.637,
    transform: "translate(126.816 92.439) rotate(-21.451)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 0.21,
    height: 0.57,
    transform: "translate(126.414 92.377) rotate(-21.801)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 0.21,
    height: 0.503,
    transform: "translate(126.012 92.293) rotate(-22.245)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 0.21,
    height: 0.436,
    transform: "translate(125.61 92.23) rotate(-22.824)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 0.21,
    height: 0.389,
    transform: "translate(125.208 92.145) rotate(-22.369)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 0.21,
    height: 0.686,
    transform: "translate(126.495 94.875) rotate(-81.12)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 0.21,
    height: 0.644,
    transform: "translate(126.219 95.171) rotate(-80.538)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.21,
    height: 0.602,
    transform: "translate(125.942 95.488) rotate(-79.876)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.21,
    height: 0.515,
    transform: "translate(125.69 95.806) rotate(-80.528)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.21,
    height: 0.449,
    transform: "translate(125.417 96.124) rotate(-81.849)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.21,
    height: 0.39,
    transform: "matrix(0.217, -0.976, 0.976, 0.217, 125.155, 96.419)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M207.981,301.8l1.249,3.281,3.281-.825-2.244,2.709,2.371,2.413-3.471-.571-.91,3.259-1.249-3.281-3.281.825,2.244-2.709-2.371-2.434,3.471.593Z",
    transform: "translate(-92.709 -212.616)",
    fill: "#d7b369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M207.52,311.527a.2.2,0,0,1-.185-.127l-1.186-3.116-3.11.783a.2.2,0,0,1-.2-.318l2.13-2.572-2.247-2.307a.2.2,0,0,1-.033-.23.2.2,0,0,1,.208-.1l3.3.563.862-3.088a.2.2,0,0,1,.375-.017l1.187,3.116,3.11-.782a.2.2,0,0,1,.2.318l-2.13,2.572,2.245,2.286a.2.2,0,0,1-.173.334l-3.3-.542-.862,3.089a.2.2,0,0,1-.181.144Zm-1.249-3.676a.2.2,0,0,1,.185.127l1.035,2.719.749-2.681a.2.2,0,0,1,.223-.142l2.874.473-1.946-1.981a.2.2,0,0,1-.011-.265l1.858-2.244-2.7.678a.2.2,0,0,1-.233-.121l-1.035-2.72-.749,2.681a.2.2,0,0,1-.224.142l-2.873-.49,1.947,2a.2.2,0,0,1,.011.264l-1.858,2.244,2.7-.678A.19.19,0,0,1,206.272,307.851Z",
    transform: "translate(-91.973 -211.88)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.691,
    height: 0.21,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 115.679, 92.419)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.648,
    height: 0.21,
    transform: "translate(115.592 91.997) rotate(-51.605)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.559,
    height: 0.21,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 115.506, 91.555)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.529,
    height: 0.21,
    transform: "translate(115.4 91.132) rotate(-53.141)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 0.45,
    height: 0.21,
    transform: "translate(115.299 90.66) rotate(-48.798)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.407,
    height: 0.21,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 115.211, 90.261)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 0.691,
    height: 0.21,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 114.515, 96.504)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 0.661,
    height: 0.21,
    transform: "matrix(0.641, -0.768, 0.768, 0.641, 114.641, 96.905)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 0.572,
    height: 0.21,
    transform: "translate(114.789 97.288) rotate(-51.005)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 0.483,
    height: 0.21,
    transform: "matrix(0.613, -0.79, 0.79, 0.613, 114.936, 97.671)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 0.47,
    height: 0.21,
    transform: "translate(115.06 98.075) rotate(-54.147)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 0.39,
    height: 0.21,
    transform: "matrix(0.651, -0.759, 0.759, 0.651, 115.193, 98.429)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 0.21,
    height: 0.692,
    transform: "matrix(0.918, -0.398, 0.398, 0.918, 116.573, 95.597)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 0.21,
    height: 0.645,
    transform: "matrix(0.919, -0.394, 0.394, 0.919, 116.996, 95.702)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 0.21,
    height: 0.57,
    transform: "translate(117.44 95.826) rotate(-21.801)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 0.21,
    height: 0.512,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 117.844, 95.937)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 0.21,
    height: 0.464,
    transform: "translate(118.288 96.063) rotate(-24.225)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 0.21,
    height: 0.398,
    transform: "translate(118.712 96.171) rotate(-25.193)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 0.21,
    height: 0.683,
    transform: "translate(117.122 93.902) rotate(-82.867)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 0.21,
    height: 0.644,
    transform: "translate(117.435 93.584) rotate(-80.538)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 0.21,
    height: 0.581,
    transform: "translate(117.772 93.266) rotate(-79.507)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 0.21,
    height: 0.515,
    transform: "translate(118.091 92.97) rotate(-80.551)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 0.21,
    height: 0.449,
    transform: "matrix(0.141, -0.99, 0.99, 0.141, 118.432, 92.674)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 0.21,
    height: 0.39,
    transform: "matrix(0.217, -0.976, 0.976, 0.217, 118.742, 92.355)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 0.21,
    height: 0.684,
    transform: "translate(113.778 92.525) rotate(-21.797)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.21,
    height: 0.629,
    transform: "translate(113.374 92.436) rotate(-19.655)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 0.21,
    height: 0.57,
    transform: "translate(112.974 92.377) rotate(-21.801)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 0.21,
    height: 0.512,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 112.552, 92.296)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 0.21,
    height: 0.436,
    transform: "translate(112.149 92.23) rotate(-22.824)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 0.21,
    height: 0.382,
    transform: "translate(111.766 92.14) rotate(-19.426)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 0.21,
    height: 0.665,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 113.054, 94.875)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 0.21,
    height: 0.623,
    transform: "translate(112.778 95.171) rotate(-80.217)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 0.21,
    height: 0.581,
    transform: "matrix(0.182, -0.983, 0.983, 0.182, 112.501, 95.489)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 0.21,
    height: 0.515,
    transform: "translate(112.249 95.806) rotate(-80.528)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 0.21,
    height: 0.449,
    transform: "translate(111.977 96.124) rotate(-81.849)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 0.21,
    height: 0.411,
    transform: "translate(111.695 96.419) rotate(-78.099)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M335.081,301.8l1.249,3.281,3.281-.825-2.244,2.709,2.371,2.413-3.471-.571-.91,3.259-1.228-3.281-3.3.825,2.244-2.709-2.371-2.434,3.471.593Z",
    transform: "translate(-192.908 -212.616)",
    fill: "#d7b369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M334.62,311.527a.2.2,0,0,1-.185-.128l-1.166-3.115-3.131.783a.2.2,0,0,1-.2-.318l2.131-2.572-2.247-2.307a.2.2,0,0,1,.175-.333l3.3.563.862-3.088a.2.2,0,0,1,.181-.144.194.194,0,0,1,.194.127l1.186,3.116,3.11-.782a.2.2,0,0,1,.2.318l-2.13,2.572,2.245,2.286a.2.2,0,0,1-.173.334l-3.3-.542-.862,3.089a.2.2,0,0,1-.182.144Zm-1.228-3.676a.2.2,0,0,1,.185.128l1.015,2.713.747-2.676a.2.2,0,0,1,.222-.142l2.874.473-1.946-1.981a.2.2,0,0,1-.011-.265l1.859-2.244-2.7.678a.2.2,0,0,1-.233-.121l-1.035-2.72-.749,2.681a.2.2,0,0,1-.224.142l-2.873-.49,1.947,2a.2.2,0,0,1,.011.264l-1.86,2.245,2.718-.679A.2.2,0,0,1,333.393,307.851Z",
    transform: "translate(-192.172 -211.88)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 0.691,
    height: 0.209,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 142.58, 92.418)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 0.648,
    height: 0.21,
    transform: "matrix(0.621, -0.784, 0.784, 0.621, 142.494, 91.997)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 0.572,
    height: 0.21,
    transform: "translate(142.389 91.552) rotate(-51.005)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 0.529,
    height: 0.21,
    transform: "translate(142.302 91.132) rotate(-53.175)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 0.45,
    height: 0.21,
    transform: "translate(142.201 90.66) rotate(-48.835)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 0.394,
    height: 0.21,
    transform: "translate(142.11 90.265) rotate(-53.74)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 0.678,
    height: 0.21,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 141.415, 96.505)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 0.635,
    height: 0.21,
    transform: "translate(141.561 96.91) rotate(-53.175)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.585,
    height: 0.21,
    transform: "matrix(0.651, -0.759, 0.759, 0.651, 141.671, 97.286)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 0.496,
    height: 0.21,
    transform: "translate(141.818 97.668) rotate(-50.194)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 0.47,
    height: 0.21,
    transform: "translate(141.962 98.075) rotate(-54.147)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 0.39,
    height: 0.21,
    transform: "matrix(0.651, -0.759, 0.759, 0.651, 142.094, 98.429)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 0.21,
    height: 0.684,
    transform: "translate(143.473 95.594) rotate(-21.805)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 0.21,
    height: 0.645,
    transform: "matrix(0.919, -0.394, 0.394, 0.919, 143.898, 95.702)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 0.21,
    height: 0.578,
    transform: "translate(144.321 95.83) rotate(-23.742)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 0.209,
    height: 0.503,
    transform: "translate(144.765 95.933) rotate(-22.256)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 0.21,
    height: 0.456,
    transform: "translate(145.188 96.059) rotate(-21.821)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 0.21,
    height: 0.389,
    transform: "matrix(0.925, -0.381, 0.381, 0.925, 145.611, 96.166)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 0.21,
    height: 0.683,
    transform: "matrix(0.124, -0.992, 0.992, 0.124, 144.023, 93.902)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 0.21,
    height: 0.644,
    transform: "translate(144.337 93.584) rotate(-80.538)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 0.21,
    height: 0.561,
    transform: "translate(144.673 93.266) rotate(-79.117)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 0.21,
    height: 0.515,
    transform: "translate(144.993 92.97) rotate(-80.553)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 0.21,
    height: 0.428,
    transform: "translate(145.333 92.674) rotate(-81.475)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 0.21,
    height: 0.411,
    transform: "matrix(0.206, -0.978, 0.978, 0.206, 145.645, 92.355)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.21,
    height: 0.676,
    transform: "translate(140.678 92.522) rotate(-20.146)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 0.21,
    height: 0.645,
    transform: "matrix(0.919, -0.394, 0.394, 0.919, 140.257, 92.442)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 0.21,
    height: 0.57,
    transform: "translate(139.854 92.377) rotate(-21.801)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M338.8,316.668l-.169-.466.2-.072.169.466Z",
    transform: "translate(-199.162 -223.914)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 0.21,
    height: 0.436,
    transform: "matrix(0.922, -0.388, 0.388, 0.922, 139.05, 92.23)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 0.21,
    height: 0.389,
    transform: "matrix(0.925, -0.381, 0.381, 0.925, 138.648, 92.145)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 0.209,
    height: 0.706,
    transform: "translate(139.936 94.875) rotate(-81.384)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 0.21,
    height: 0.623,
    transform: "translate(139.68 95.171) rotate(-80.216)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 0.21,
    height: 0.56,
    transform: "translate(139.403 95.488) rotate(-79.113)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 0.21,
    height: 0.515,
    transform: "translate(139.13 95.806) rotate(-80.53)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 0.21,
    height: 0.449,
    transform: "matrix(0.142, -0.99, 0.99, 0.142, 138.878, 96.124)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 0.21,
    height: 0.411,
    transform: "translate(138.596 96.419) rotate(-78.102)",
    fill: "#1b1918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M131.569,68.656h.021L132.9,64h1.778v6.265h-1.355V66.328H133.3l-1.27,3.958h-.91l-1.249-3.937h-.021v3.916H128.5V64h1.778Z",
    transform: "translate(-33.505 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M177.832,64v4.085a2.137,2.137,0,0,1-.677,1.672,2.636,2.636,0,0,1-1.8.593,2.544,2.544,0,0,1-1.778-.593,2.069,2.069,0,0,1-.677-1.672V64h1.355v4.085a1.446,1.446,0,0,0,.3.974,1.175,1.175,0,0,0,1.651,0,1.485,1.485,0,0,0,.3-.974V64Z",
    transform: "translate(-68.507 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M216.453,70.265H215.1l-2.222-4h-.021v4H211.5V64h1.355l2.222,4h.021V64h1.355Z",
    transform: "translate(-98.937 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M252.055,70.265H250.7V64h1.355Z",
    transform: "translate(-129.84 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M277.02,68h0a1.751,1.751,0,0,1-.571,1.524,3.05,3.05,0,0,1-3.492-.085,2.141,2.141,0,0,1-.656-1.693V65.886a2.234,2.234,0,0,1,.635-1.693,2.435,2.435,0,0,1,1.736-.593,2.778,2.778,0,0,1,1.778.508,1.794,1.794,0,0,1,.593,1.5v.021h-1.312a1.265,1.265,0,0,0-.233-.847,1.077,1.077,0,0,0-.8-.233.874.874,0,0,0-.762.339,1.628,1.628,0,0,0-.254,1.016V67.77a1.5,1.5,0,0,0,.275,1.016,1.065,1.065,0,0,0,.825.339.977.977,0,0,0,.72-.233,1.274,1.274,0,0,0,.212-.847h1.312V68Z",
    transform: "translate(-146.868 -24.833)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M310.755,70.265H309.4V64h1.355Z",
    transform: "translate(-176.116 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M333.055,68v2.265H331.7V64h2.349a2.448,2.448,0,0,1,1.672.55,1.994,1.994,0,0,1,0,2.879,2.448,2.448,0,0,1-1.672.55l-.995.021Zm0-.952h.995a.894.894,0,0,0,.7-.3,1.074,1.074,0,0,0,.233-.741,1.255,1.255,0,0,0-.233-.762.864.864,0,0,0-.7-.3h-.995Z",
    transform: "translate(-193.696 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M369.755,70.265H368.4V64h1.355Z",
    transform: "translate(-222.628 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M395.332,64v4.085a2.137,2.137,0,0,1-.677,1.672,2.636,2.636,0,0,1-1.8.593,2.544,2.544,0,0,1-1.778-.593,2.069,2.069,0,0,1-.677-1.672V64h1.355v4.085a1.446,1.446,0,0,0,.3.974,1.175,1.175,0,0,0,1.651,0,1.485,1.485,0,0,0,.3-.974V64Z",
    transform: "translate(-239.972 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M430.255,69.334h2.625v.952H428.9V64h1.355Z",
    transform: "translate(-270.323 -25.148)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M127.3,120.237V106.5h5.5a9.487,9.487,0,0,1,3.027.36,3.006,3.006,0,0,1,1.5,1.312,4.114,4.114,0,0,1,.571,2.159,3.828,3.828,0,0,1-.868,2.561,3.955,3.955,0,0,1-2.561,1.27,6.521,6.521,0,0,1,1.4,1.143,16.31,16.31,0,0,1,1.482,2.222l1.587,2.688h-3.133l-1.884-2.984a24.258,24.258,0,0,0-1.376-2.011,2.119,2.119,0,0,0-.783-.571,4.035,4.035,0,0,0-1.312-.148h-.529v5.736Zm2.6-7.937h1.947a9.837,9.837,0,0,0,2.349-.169,1.418,1.418,0,0,0,.741-.571,1.932,1.932,0,0,0,.275-1.037,1.738,1.738,0,0,0-.36-1.122,1.58,1.58,0,0,0-.995-.529c-.212-.021-.847-.042-1.9-.042H129.9V112.3Z",
    transform: "translate(-32.559 -58.653)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M189.1,120.237V106.5h9.609v2.328H191.7v3.048h6.519v2.307H191.7v3.746h7.239v2.307Z",
    transform: "translate(-81.278 -58.653)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M250.577,114.232v-2.307h5.651v5.461a6.722,6.722,0,0,1-2.392,1.482,8.307,8.307,0,0,1-3.154.635,6.737,6.737,0,0,1-3.556-.91,5.517,5.517,0,0,1-2.265-2.582,8.8,8.8,0,0,1-.762-3.662,8.148,8.148,0,0,1,.847-3.81,6.024,6.024,0,0,1,2.476-2.561,6.27,6.27,0,0,1,3.111-.677,5.871,5.871,0,0,1,3.768,1.079,4.934,4.934,0,0,1,1.757,2.963l-2.6.508a2.879,2.879,0,0,0-1.037-1.587,3.077,3.077,0,0,0-1.884-.593,3.471,3.471,0,0,0-2.73,1.143,5,5,0,0,0-1.016,3.408,5.6,5.6,0,0,0,1.016,3.662,3.377,3.377,0,0,0,2.688,1.228,4.192,4.192,0,0,0,1.651-.339,6.1,6.1,0,0,0,1.418-.825v-1.736l-2.984.021Z",
    transform: "translate(-124.637 -57.707)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M312.8,120.237V106.5h2.625v5.4h5.122v-5.4h2.625v13.737h-2.625v-6.011h-5.122v6.011Z",
    transform: "translate(-178.796 -58.653)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M374.2,120.237V106.5h2.625v13.737Z",
    transform: "translate(-227.2 -58.653)",
    fill: "#006ab3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M398.5,120.237V106.5h2.54l5.313,9.165V106.5h2.434v13.737h-2.625l-5.228-8.953v8.953Z",
    transform: "translate(-246.357 -58.653)",
    fill: "#006ab3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiglaReghin);
export default __webpack_public_path__ + "static/media/siglaReghin.982e1616e021db31155884ab822bd8bf.svg";
export { ForwardRef as ReactComponent };